import React, { Suspense, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
  useToast,
  HStack,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Tooltip,
  Flex,
  useDisclosure,
  Spinner,
  MenuItem,
  MenuList,
  Menu,
  MenuButton,
  Checkbox,
} from '@chakra-ui/react';
import { FiCreditCard, FiDollarSign, FiEdit } from 'react-icons/fi';
import axios from 'axios';
import { FaCreditCard, FaPrint } from 'react-icons/fa';
import FacturacionComponent from 'views/Facturacion/PagoAPManual';
import CrearActualizarToma from 'views/AguaPotable/AltaToma';
import TransaccionDetails from './DetallePagos';
import { ChevronDownIcon } from '@chakra-ui/icons';
interface Toma {
  id: string;
  idPropietario: string;
  idTomasx: string;
  fechaVinculacion: string;
  usuarioVinculacion: string | null;
  Tomasx: {
    Cuenta: number;
    Subcuenta?: number | null;
    domicilio: string;
    fechaAlta: string;
    municipio: string;
  };
  Propietario: {
    nombre: string;
    primerApellido: string;
    segundoApellido: string;
    rfc: string;
  };
}
interface Pago {
  estatus_de_cancelacion: string;
  RFCReceptor: string;
  ID: string;
  Fecha: string;
  Monto: number;
  MetodoPago: string;
  UUID: string;
}

interface HistorialPagosProps {
  idClaveCatastral: string;
}

const HistorialPagosAP: React.FC<HistorialPagosProps> = ({
  idClaveCatastral,
}) => {
  const [tomas, setTomas] = useState<Toma[]>([]);
  const [pagos, setPagos] = useState<Record<string, Pago[]>>({});
  const [selectedToma, setSelectedToma] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [incluirSinTimbrar, setIncluirSinTimbrar] = useState(false);
  const {
    isOpen: isBajaOpen,
    onOpen: onBajaOpen,
    onClose: onBajaClose,
  } = useDisclosure();

  useEffect(() => {
    const fetchTomas = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/tomasx/propietario_tomas?propietarioId=${idClaveCatastral}`,
        );

        console.log('Tomas recibidas:', response.data);
        setTomas(response.data);

        if (response.data.length > 0) {
          console.log('Primera toma:', response.data[0]);
          console.log('Subcuenta de primera toma:', response.data[0].Tomasx?.Subcuenta);
          setSelectedToma(response.data[0].idTomasx);
          await fetchPagos(
            'AP-' + response.data[0].Tomasx.Cuenta,
            response.data[0].idTomasx,
            response.data[0].Tomasx?.Subcuenta
          );
        }
      } catch (error) {
        console.error('Error al obtener tomas:', error);
        toast({
          title: 'Error al cargar datos',
          description: 'No se pudieron cargar las tomas del propietario.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTomas();
  }, [idClaveCatastral]);

  // Recargar pagos cuando cambie incluirSinTimbrar
  useEffect(() => {
    if (tomas.length > 0) {
      tomas.forEach((toma) => {
        fetchPagos(
          'AP-' + toma.Tomasx.Cuenta,
          toma.idTomasx,
          toma.Tomasx?.Subcuenta
        );
      });
    }
  }, [incluirSinTimbrar]);
  const [selectedPagoId, setSelectedPagoId] = useState<string | null>(null);
  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  const handleVerDetalle = (pagoId: string) => {
    setSelectedPagoId(pagoId);
    onDetailOpen();
  };

  const fetchPagos = async (idToma: string, id: string, subcuenta?: number | null) => {
    try {
      console.log('fetchPagos - idToma:', idToma, 'subcuenta:', subcuenta);
      let url = '';
      if (subcuenta !== undefined && subcuenta !== null && subcuenta !== 0) {
        url = `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones/agua_prop/${idToma}?subcuenta=${subcuenta}&incluirSinTimbrar=${incluirSinTimbrar}`;
      } else {
        url = `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones/agua_prop/${idToma}?incluirSinTimbrar=${incluirSinTimbrar}`;
      }

      console.log('URL construida:', url);
      const response = await axios.get(url);
      console.log('Pagos recibidos:', response.data);

      setPagos((prev) => ({
        ...prev,
        [id]: response.data.transacciones || response.data,
      }));
    } catch (error) {
      console.error(`Error al obtener pagos para la toma ${idToma}:`, error);
    }
  };

  const {
    // isOpen: isHistorialPagosAPOpenX,
    onOpen: onHistorialPagosAPOpenX,
    onClose: onHistorialPagosAPCloseX,
  } = useDisclosure();
  const [selectedPropietario, setSelectedPropietario] = useState<string | null>(
    null,
  );
  const [tabSeleccionada, setTabSeleccionada] = useState<string>('T-5690');
  const [isHistorialPagosAPOpenX, setHistorialPagosAPOpenX] = useState(false);
  const [selectedTomax, setSelectedTomax] = useState<Toma | null>(null); // Guarda la toma completa

  const openPagoModal = (toma: Toma, ocultarAdeudo = false) => {
    setSelectedTomax(toma);
    setHistorialPagosAPOpenX(true);
    if (ocultarAdeudo) {
      setMostrarAdeudo(false);
    }
  };

  const closePagoModal = () => {
    setHistorialPagosAPOpenX(false);
    setSelectedTomax(null);
   // setMostrarAdeudo(true);
  };

  // Definir la interfaz para los detalles del cobro
  interface DetallesCobro {
    totalAgua: number;
    totalDrenaje: number;
  }

  // Estado con la interfaz definida
  const [Detalles, setDetalles] = useState<DetallesCobro>({
    totalAgua: 0,
    totalDrenaje: 0,
  });

  const [cobroTotal, setCobroTotal] = useState<number | null>(null);
  const [mostrarAdeudo, setMostrarAdeudo] = useState<boolean>(true);
  // const toast = useToast();

  const [saldoVencidoPredio, setSaldoVencidoPredio] = useState<number>(200);
  const [saldoVencidoAgua, setSaldoVencidoAgua] = useState<number>(150);
  const [esDeudor, setEsDeudor] = useState<boolean>(
    saldoVencidoPredio > 0 || saldoVencidoAgua > 0,
  );
  const [isPagoModalOpen, setPagoModalOpen] = useState(false);
  const [isPagarSaldoVencidoOpen, setPagarSaldoVencidoOpen] = useState(false);
  const [montoRecibido, setMontoRecibido] = useState<number>(0);
  const toast = useToast();

  const handlePagoAdelantado = () => setPagoModalOpen(true);
  const handleCalcularCobro = async () => {
    const tomaActual = tomas.find(t => t.idTomasx === selectedToma);
    if (!tomaActual) return;

    const numeroToma = `AP-${tomaActual.Tomasx.Cuenta}`;
    const subcuenta = tomaActual.Tomasx.Subcuenta;

    try {
      const url = subcuenta !== undefined && subcuenta !== null
        ? `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/agua/transacciones/${numeroToma}?subcuenta=${subcuenta}`
        : `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/agua/transacciones/${numeroToma}`;

      const response = await axios.get(url);
      const { calculoDeuda } = response.data;

      if (calculoDeuda) {
        setMostrarAdeudo(true);
        setCobroTotal(calculoDeuda.totalCompletoMXN);
        setDetalles({
          totalAgua: calculoDeuda.totalAguaCompletoMXN,
          totalDrenaje: calculoDeuda.totalDrenajeCompletoMXN,
        });

        toast({
          title: 'Cálculo realizado',
          description: `El cobro total es de $${calculoDeuda.totalCompletoMXN}.`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: 'Sin adeudo',
          description: 'No hay adeudo pendiente para esta toma.',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error al calcular el cobro:', error);
      toast({
        title: 'Error al calcular',
        description: 'No se pudo calcular el cobro. Inténtalo de nuevo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleConfirmarPago = () => {
    toast({
      title: 'Pago Realizado',
      description: 'Su pago adelantado ha sido confirmado.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    setPagoModalOpen(false);
  };

  const handlePagarSaldoVencido = () => {
    const nuevoSaldoPredio = Math.max(0, saldoVencidoPredio - montoRecibido);
    const nuevoSaldoAgua = Math.max(
      0,
      saldoVencidoAgua - (montoRecibido - saldoVencidoPredio),
    );
    setSaldoVencidoPredio(nuevoSaldoPredio);
    setSaldoVencidoAgua(nuevoSaldoAgua);
    setEsDeudor(nuevoSaldoPredio > 0 || nuevoSaldoAgua > 0);

    toast({
      title: 'Pago Realizado',
      description: 'Pago de saldo vencido realizado con éxito.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    setPagarSaldoVencidoOpen(false);
  };

  const handleTabChange = (index: number) => {
    const selected = tomas[index]?.idTomasx;
    setSelectedToma(selected);
    setCobroTotal(null);

    console.log('Toma seleccionada:', tomas[index]);
    console.log('Subcuenta:', tomas[index].Tomasx?.Subcuenta);
    fetchPagos(
      'AP-' + tomas[index].Tomasx.Cuenta.toString(),
      tomas[index].idTomasx,
      tomas[index].Tomasx?.Subcuenta
    );
  };

  const imprimirEstadoDeCuenta = async (toma: Toma) => {
    const numeroToma = `AP-${toma.Tomasx.Cuenta}`;
    const subcuenta = toma.Tomasx.Subcuenta;

    try {
      const url =
        subcuenta !== undefined && subcuenta !== null
          ? `${process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000'}/api/agua/transacciones/${numeroToma}?subcuenta=${subcuenta}`
          : `${process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000'}/api/agua/transacciones/${numeroToma}`;

      const response = await axios.get(url);
      const { calculoDeuda, datosToma } = response.data;

      if (!datosToma) {
        toast({
          title: 'Sin datos',
          description: 'No hay informacion disponible para imprimir.',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const calculo =
        calculoDeuda || {
          tipo: 'N/A',
          mesActual: new Date().getMonth() + 1,
          anoActual: new Date().getFullYear(),
          mesPago: new Date().getMonth() + 1,
          anoPago: new Date().getFullYear(),
          pagoAguaBaseMXN: 0,
          recargosTotalesMXN: 0,
          subtotalAguaRecargosMXN: 0,
          drenajeTotalMXN: 0,
          pagoAdelantadoMXN: 0,
          drenajeAdelantadoMXN: 0,
          totalAguaCompletoMXN: 0,
          totalDrenajeCompletoMXN: 0,
          totalCompletoMXN: 0,
        };

      const fechaEmision = new Date();
      const fecha = fechaEmision.toLocaleDateString('es-MX');
      const hora = fechaEmision.toLocaleTimeString('es-MX', {
        hour: '2-digit',
        minute: '2-digit',
      });

      const periodoAdeudo = calculoDeuda
        ? `${String(calculoDeuda.mesPago).padStart(2, '0')}/${calculoDeuda.anoPago} - ${String(calculoDeuda.mesActual).padStart(2, '0')}/${calculoDeuda.anoActual}`
        : 'Al corriente';

      const propietarioNombre = datosToma.propietario
        ? `${datosToma.propietario.nombre} ${datosToma.propietario.primerApellido} ${datosToma.propietario.segundoApellido}`.trim()
        : 'N/A';

      const formatCurrency = (value?: number) =>
        `$${Number(value ?? 0).toFixed(2)}`;

      const htmlResponse = await fetch('/Adeudos/estado_agua.html');
      let htmlContent = await htmlResponse.text();

      htmlContent = htmlContent
        .replace(/{{FECHA_COMPLETA}}/g, `${fecha} ${hora}`)
        .replace(/{{FOLIO}}/g, toma.idTomasx || 'N/A')
        .replace(/{{PROPIETARIO}}/g, propietarioNombre)
        .replace(/{{DOMICILIO}}/g, datosToma.domicilio || 'N/A')
        .replace(/{{CUENTA}}/g, numeroToma)
        .replace(
          /{{SUBCUENTA}}/g,
          subcuenta !== undefined && subcuenta !== null
            ? subcuenta.toString()
            : 'N/A',
        )
        .replace(/{{TIPO_TOMA}}/g, calculo.tipo || 'N/A')
        .replace(/{{TARIFA}}/g, datosToma.tarifa || 'N/A')
        .replace(/{{PERIODO_ADEUDO}}/g, periodoAdeudo)
        .replace(
          /{{SUBTOTAL_AGUA}}/g,
          formatCurrency(calculo.subtotalAguaRecargosMXN),
        )
        .replace(/{{RECARGOS}}/g, formatCurrency(calculo.recargosTotalesMXN))
        .replace(/{{TOTAL_AGUA}}/g, formatCurrency(calculo.totalAguaCompletoMXN))
        .replace(
          /{{TOTAL_DRENAJE}}/g,
          formatCurrency(calculo.totalDrenajeCompletoMXN),
        )
        .replace(/{{TOTAL}}/g, formatCurrency(calculo.totalCompletoMXN))
        .replace(/{{ELABORO}}/g, 'Tesoreria Municipal');

      const printWindow = window.open('', '_blank');

      if (!printWindow) {
        toast({
          title: 'Aviso',
          description: 'No se pudo abrir la ventana de impresion.',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      printWindow.document.write(htmlContent);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => printWindow.print(), 500);
    } catch (error) {
      console.error('Error al generar estado:', error);
      toast({
        title: 'Error',
        description: 'No se pudo generar el estado de cuenta.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      p={8}
      bg="linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"
      borderRadius="xl"
      boxShadow="2xl"
      maxW="1400px"
      mx="auto"
    >
      <Modal isOpen={isDetailOpen} onClose={onDetailClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {selectedPagoId && (
              <TransaccionDetails transaccionId={selectedPagoId} />
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onDetailClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <HStack spacing={2} mb={6} justify="flex-start">
        <Tooltip label="Consulta el adeudo del contribuyente">
          <Button
            colorScheme="teal"
            leftIcon={<FiDollarSign />}
            onClick={handleCalcularCobro}
            size="sm"
          >
            Calcular Adeudo
          </Button>
        </Tooltip>
        <Tooltip label="Editar toma">
          <Button
            colorScheme="yellow"
            leftIcon={<FiEdit />}
            onClick={onBajaOpen}
            size="sm"
          >
            Editar
          </Button>
        </Tooltip>
        <Tooltip label="Realizar pago manual">
          <Button
            colorScheme="green"
            leftIcon={<FaCreditCard />}
            onClick={async () => {
              const tomaActual = tomas.find(t => t.idTomasx === selectedToma);
              if (!tomaActual) return;

              const numeroToma = `AP-${tomaActual.Tomasx.Cuenta}`;
              const subcuenta = tomaActual.Tomasx.Subcuenta;

              try {
                const url = subcuenta !== undefined && subcuenta !== null
                  ? `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/agua/transacciones/${numeroToma}?subcuenta=${subcuenta}`
                  : `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/agua/transacciones/${numeroToma}`;

                const response = await axios.get(url);
                const { calculoDeuda } = response.data;

                if (calculoDeuda) {
                  setCobroTotal(calculoDeuda.totalCompletoMXN);
                  setDetalles({
                    totalAgua: calculoDeuda.totalAguaCompletoMXN,
                    totalDrenaje: calculoDeuda.totalDrenajeCompletoMXN,
                  });
                  openPagoModal(tomaActual, true);
                } else {
                  setCobroTotal(0);
                  setDetalles({ totalAgua: 0, totalDrenaje: 0 });
                  openPagoModal(tomaActual, true);
                }
              } catch (error) {
                console.error('Error al calcular el cobro:', error);
                toast({
                  title: 'Error',
                  description: 'No se pudo calcular el adeudo. Inténtalo de nuevo.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
              }
            }}
            size="sm"
          >
            Pago Manual
          </Button>
        </Tooltip>
        <Tooltip label="Imprimir estado de cuenta">
          <Button
            colorScheme="blue"
            leftIcon={<FaPrint />}
            onClick={async () => {
              const tomaActual = tomas.find(t => t.idTomasx === selectedToma);
              if (!tomaActual) return;

              await imprimirEstadoDeCuenta(tomaActual);
            }}
            size="sm"
          >
            Imprimir Estado
          </Button>
        </Tooltip>
      </HStack>

      <Divider mb={6} />

      <Tabs 
        isFitted 
        variant="enclosed" 
        onChange={handleTabChange}
        colorScheme="teal"
      >
        <TabList 
          mb="1em" 
          bg="white" 
          borderRadius="lg" 
          p={2} 
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
        >
          {tomas.map((toma) => (
            <Tab 
              key={toma.idTomasx}
              _selected={{
                bg: "linear-gradient(135deg, #681a2d 0%, #5b182b 100%)",
                color: "white",
                fontWeight: "bold",
                borderRadius: "md",
                boxShadow: "lg",
                transform: "scale(1.05)",
              }}
              _hover={{
                bg: "#f0e6d2",
                transform: "scale(1.02)",
              }}
              transition="all 0.2s"
              fontWeight="semibold"
              fontSize="sm"
              color="gray.700"
            >
              💧 Toma: {toma.Tomasx.Cuenta}
              {toma.Tomasx.Subcuenta !== null && toma.Tomasx.Subcuenta !== undefined && ` - ${toma.Tomasx.Subcuenta}`}
            </Tab>
          ))}
        </TabList>

        {/* Checkbox para incluir pagos sin timbrar */}
        <Box mb={4} px={2}>
          <Checkbox
            isChecked={incluirSinTimbrar}
            onChange={(e) => setIncluirSinTimbrar(e.target.checked)}
            colorScheme="teal"
            size="md"
          >
            Incluir pagos sin timbrar
          </Checkbox>
        </Box>

        <TabPanels>
          {tomas.map((toma) => (
            <TabPanel key={toma.idTomasx}>
              <Box 
                overflowX="auto" 
                maxHeight="450px" 
                overflowY="auto"
                borderRadius="lg"
                boxShadow="lg"
                bg="white"
                border="1px solid"
                borderColor="gray.200"
              >
                <Table variant="simple" size="sm">
                  <Thead
                    position="sticky"
                    top={0}
                    bg="linear-gradient(135deg, #681a2d 0%, #5b182b 100%)"
                    zIndex={1}
                  >
                    <Tr>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>Fecha de Pago</Th>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>Monto</Th>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>Tipo de Pago</Th>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>Estado</Th>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>UUID</Th>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>Estado de Cancelación</Th>
                      <Th color="white" fontSize="xs" textTransform="uppercase" py={4}>Acciones</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {pagos[toma.idTomasx]?.map((pago, index) => (
                      <Tr 
                        key={pago.ID}
                        bgColor={
                          pago.estatus_de_cancelacion === 'CANCELADO'
                            ? 'red.50'
                            : index % 2 === 0
                            ? 'gray.50'
                            : 'white'
                        }
                        _hover={{
                          bg: pago.estatus_de_cancelacion === 'CANCELADO' ? 'red.100' : '#f0e6d2',
                          transition: 'all 0.2s'
                        }}
                        borderBottom="1px solid"
                        borderColor="gray.200"
                      >
                        <Td>
                          <Text fontSize="sm" color="gray.700">
                            {new Date(pago.Fecha).toLocaleDateString('es-MX', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            })}
                          </Text>
                          <Text fontSize="xs" color="gray.500">
                            {new Date(pago.Fecha).toLocaleTimeString('es-MX', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </Text>
                        </Td>
                        <Td>
                          <Text
                            fontSize="sm"
                            fontWeight="bold"
                            color={pago.Monto > 0 ? '#16a34a' : 'gray.500'}
                          >
                            ${pago.Monto.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </Text>
                        </Td>
                        <Td>
                          <Box
                            as="span"
                            px={3}
                            py={1}
                            bg="#bb8c52"
                            color="white"
                            borderRadius="full"
                            fontSize="xs"
                            fontWeight="bold"
                            display="inline-block"
                          >
                            {pago.MetodoPago}
                          </Box>
                        </Td>
                        <Td>
                          <Box
                            as="span"
                            px={3}
                            py={1}
                            bg={pago.UUID ? '#16a34a' : '#f59e0b'}
                            color="white"
                            borderRadius="full"
                            fontSize="xs"
                            fontWeight="bold"
                            display="inline-block"
                          >
                            {pago.UUID ? '✓ Pagado' : '⏳ Pendiente'}
                          </Box>
                        </Td>
                        <Td>
                          <Text fontSize="xs" color="gray.600" noOfLines={1}>
                            {pago.UUID || 'N/A'}
                          </Text>
                        </Td>
                        <Td>
                          <Box
                            as="span"
                            px={3}
                            py={1}
                            bg={pago.estatus_de_cancelacion === 'CANCELADO' ? '#dc2626' : '#16a34a'}
                            color="white"
                            borderRadius="full"
                            fontSize="xs"
                            fontWeight="bold"
                            display="inline-block"
                          >
                            {pago.estatus_de_cancelacion === 'CANCELADO' ? '✗ CANCELADO' : '✓ ACTIVO'}
                          </Box>
                        </Td>
                        <Td>
                        <Menu>
                          <MenuButton
                            as={Button}
                            size="sm"
                            rightIcon={<ChevronDownIcon />}
                            bg="#681a2d"
                            color="white"
                            _hover={{ bg: "#5b182b" }}
                            _active={{ bg: "#4a1320" }}
                          >
                            Acciones
                          </MenuButton>
                          <MenuList zIndex={9999}>
                            {pago.UUID === null ? (
                              <MenuItem
                                onClick={async () => {
                                  try {
                                    //OBSIDIAN PRUEBAS 2025
                                    const response = await axios.get(
                                      `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Facturacion/generarx-prod/${pago.ID}`,
                                      {
                                        responseType: 'blob',
                                      },
                                    );

                                    const xmlBlob = new Blob([response.data], {
                                      type: 'application/xml',
                                    });
                                    const xmlUrl = URL.createObjectURL(xmlBlob);

                                    const link = document.createElement('a');
                                    link.href = xmlUrl;
                                    link.setAttribute(
                                      'download',
                                      `CFDI_${pago.ID}.xml`,
                                    );
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);

                                    toast({
                                      title: 'Éxito',
                                      description:
                                        'CFDI generado y descargado correctamente.',
                                      status: 'success',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } catch (error) {
                                    console.error(
                                      'Error al generar el CFDI:',
                                      error,
                                    );
                                    toast({
                                      title: 'Error',
                                      description:
                                        'No se pudo generar el CFDI. Intenta de nuevo.',
                                      status: 'error',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  }
                                }}
                              >
                                Facturar
                              </MenuItem>
                            ) : (
                              <MenuItem
                                onClick={async () => {
                                  setLoading(true); // Activa el bloqueo de pantalla

                                  try {
                                    const response = await axios.get(
                                      `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones/ImprimirAgua/` +
                                        pago.ID,
                                      {
                                        responseType: 'blob',
                                      },
                                    );

                                    const pdfBlob = new Blob([response.data], {
                                      type: 'application/pdf',
                                    });
                                    const pdfUrl = URL.createObjectURL(pdfBlob);
                                    window.open(pdfUrl, '_blank');

                                    // const link =
                                    //   document.createElement('a');
                                    // link.href = pdfUrl;
                                    // link.setAttribute(
                                    //   'download',
                                    //   `CFDI_${pago.UUID}.pdf`,
                                    // );
                                    // document.body.appendChild(link);
                                    // link.click();
                                    // document.body.removeChild(link);

                                    toast({
                                      title: 'Éxito',
                                      description:
                                        'CFDI descargado correctamente.',
                                      status: 'success',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } catch (error) {
                                    console.error(
                                      'Error al descargar el CFDI:',
                                      error,
                                    );
                                    toast({
                                      title: 'Error',
                                      description:
                                        'No se pudo descargar el CFDI. Intenta de nuevo.',
                                      status: 'error',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } finally {
                                    setLoading(false);
                                  }
                                }}
                              >
                                Imprimir CFDI
                              </MenuItem>
                            )}
                            <MenuItem onClick={() => handleVerDetalle(pago.ID)}>
                              Ver Detalle
                            </MenuItem>
                            <MenuItem
  onClick={() => {
    const downloadUrl = `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Facturacion/descargar/${pago.UUID}`;
    window.open(downloadUrl, '_blank');
  }}
>
  Descargar XML
</MenuItem>

                            <MenuItem
                              onClick={async () => {
                                let toastId; // Identificador para el toast
                                try {
                                  // Mostrar un toast indicando que se está procesando la cancelación
                                  toastId = toast({
                                    title: 'Procesando',
                                    description:
                                      'La cancelación del CFDI está en curso, espera un momento.',
                                    status: 'info',
                                    duration: null, // El toast permanece visible hasta que lo cierres manualmente
                                    isClosable: true,
                                  });

                                  // Datos requeridos por el backend
                                  const requestData = {
                                    user: 'usuario_desde_bd',
                                    pass: 'password_desde_bd',
                                    rfcEmisor: 'RFC_desde_bd',
                                    listaCFDI: [
                                      {
                                        EsCancelable: true, // Supón que el CFDI es cancelable
                                        FolioSustitucion: '', // Si aplica, puedes incluirlo
                                        Motivo: '03', // Motivo de cancelación: "No se llevó a cabo la operación"
                                        RFCReceptor:
                                          pago.RFCReceptor || 'XAXX010101000',
                                        Total: pago.Monto,
                                        UUID: pago.UUID, // UUID del CFDI que se desea cancelar
                                      },
                                    ],
                                  };

                                  // Realizar la solicitud POST al backend
                                  const response = await axios.post(
                                    `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Facturacion/cancelar-cfdi`,
                                    requestData,
                                    { responseType: 'blob' }, // Asegúrate de recibir el archivo como blob
                                  );

                                  if (response.data) {
                                    // Crear un blob a partir del XML
                                    const xmlBlob = new Blob([response.data], {
                                      type: 'application/xml',
                                    });

                                    // Crear un enlace para descargar el archivo
                                    const xmlUrl = URL.createObjectURL(xmlBlob);
                                    const link = document.createElement('a');
                                    link.href = xmlUrl;
                                    link.setAttribute(
                                      'download',
                                      `Cancelacion_CFDI_${pago.UUID}.xml`,
                                    );

                                    // Simular clic en el enlace para iniciar la descarga
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);

                                    // Cerrar el toast de progreso y mostrar uno de éxito
                                    toast.close(toastId);
                                    toast({
                                      title: 'Éxito',
                                      description:
                                        'El CFDI fue cancelado y el XML se descargó correctamente.',
                                      status: 'success',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } else {
                                    // Cerrar el toast de progreso y mostrar uno de error
                                    toast.close(toastId);
                                    toast({
                                      title: 'Error',
                                      description:
                                        'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                      status: 'error',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  }
                                } catch (error) {
                                  console.error(
                                    'Error al cancelar el CFDI:',
                                    error,
                                  );

                                  // Cerrar el toast de progreso y mostrar uno de error
                                  toast.close(toastId);
                                  toast({
                                    title: 'Error',
                                    description:
                                      'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                    status: 'error',
                                    duration: 5000,
                                    isClosable: true,
                                  });
                                }
                              }}
                            >
                              Cancelar CFDI
                            </MenuItem>
                          </MenuList>
                        </Menu>
                        </Td>
                      </Tr>
                    )) || (
                      <Tr>
                        <Td colSpan={7} textAlign="center" py={8}>
                          <Text color="gray.500" fontSize="md">
                            No hay pagos registrados para esta toma.
                          </Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </Box>

              {cobroTotal !== null && mostrarAdeudo && (
                <Flex justify="center" align="center" bg="gray.100">
                  <VStack
                    spacing={4}
                    bg="white"
                    p={4}
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.300"
                    boxShadow="lg"
                    width="100%"
                    maxW="450px"
                    alignSelf="center"
                  >
                    <Box
                      textAlign="center"
                      borderBottom="1px solid"
                      borderColor="gray.200"
                      pb={3}
                      width="100%"
                    >
                      <Text fontSize="xl" fontWeight="bold" color="gray.700">
                        Adeudo del Contribuyente
                      </Text>
                      <Text fontSize="sm" color="gray.500">
                        Fecha: {new Date().toLocaleDateString()}
                      </Text>
                    </Box>

                    <VStack spacing={2} align="stretch">
                      <HStack justifyContent="space-between">
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                        >
                          Agua:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.800"
                        >
                          ${Detalles.totalAgua}
                        </Text>
                      </HStack>
                      <HStack justifyContent="space-between">
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                        >
                          Alcantarillado:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.800"
                        >
                          ${Detalles.totalDrenaje}
                        </Text>
                      </HStack>
                      <HStack justifyContent="space-between">
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                        >
                          Recargos:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.800"
                        >
                          ${0.0} (.DEV)
                        </Text>
                      </HStack>
                      <Divider borderColor="gray.300" />
                      <HStack justifyContent="space-between">
                        <Text fontSize="md" fontWeight="bold" color="green.600">
                          TOTAL:
                        </Text>
                        <Text fontSize="md" fontWeight="bold" color="green.600">
                          ${cobroTotal}
                        </Text>
                      </HStack>
                    </VStack>

                    <Box textAlign="center" mt={2}>
                      <HStack spacing={4} justify="center">
                        <Button
                          colorScheme="green"
                          size="md"
                          borderRadius="md"
                          leftIcon={<FaCreditCard />}
                          onClick={() => openPagoModal(toma)}
                        >
                          Pagar Ahora
                        </Button>

                        <Button
                          colorScheme="blue"
                          size="md"
                          borderRadius="md"
                          leftIcon={<FaPrint />}
                          onClick={() => imprimirEstadoDeCuenta(toma)}
                        >
                          Imprimir Estado
                        </Button>
                      </HStack>
                    </Box>
                  </VStack>
                </Flex>
              )}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
      <Modal isOpen={isBajaOpen} onClose={onBajaClose} size="5xl">
        <ModalOverlay />
        <ModalContent
          bg="transparent" // Hace la modal completamente transparente
          boxShadow="none" // Elimina cualquier sombra
        >
          <ModalCloseButton />
          <ModalBody p={0}>
            <Suspense fallback={<Spinner />}>
              <CrearActualizarToma
                idPropietario={Number(selectedToma)}
                alta={false}
              />
            </Suspense>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isHistorialPagosAPOpenX}
        onClose={closePagoModal}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {selectedToma && (
              <FacturacionComponent
                data={selectedTomax} // Pasamos toda la toma seleccionada
                //idClaveCatastral={selectedTomax.Tomasx.Cuenta}  // Pasar el id de toma
                monto={cobroTotal}
                // pagoid={selectedTomax.idPropietario}  // Pasar el id de propietario
                onClose={closePagoModal} // Pasamos la función de cierre
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default HistorialPagosAP;
